import { useState, useEffect, useCallback } from "react";
import { leaveEncashmentService } from "../services/leaveEncashmentService";

export const useLeaveEncashment = ({ showGeneralMessage, apiFilterPayload }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      // Pass both filters and selectedYear to the service
      const res = await leaveEncashmentService.getLeaveBalances(apiFilterPayload, selectedYear);
      console.log("API leaveEncashmentService.getLeaveBalances", res.config.data);
      const employees = res.data.employees || [];
      setData(employees);
      setOriginalData(employees);
    } catch (err) {
      console.error("Fetch Error:", err);
      showGeneralMessage("Failed to retrieve balances", false);
    } finally {
      setLoading(false);
    }
  }, [apiFilterPayload, selectedYear, showGeneralMessage]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleSearch = (value) => {
    if (!value || value.trim() === "") {
      setData(originalData);
      return;
    }
    const lower = value.toLowerCase();
    const filtered = originalData.filter(emp =>
      emp.fullName?.toLowerCase().includes(lower) ||
      emp.employeeId?.toString().toLowerCase().includes(lower)
    );
    setData(filtered);
  };

  const postToPayroll = async (employeeIds, payrollPeriodId, targetProcess = "payroll") => {
    setLoading(true);
    try {
      if (targetProcess === "finalpay") {
        await leaveEncashmentService.syncToFinalPay(employeeIds, payrollPeriodId, selectedYear);
      } else {
        await leaveEncashmentService.syncToPayroll(employeeIds, payrollPeriodId, selectedYear);
      }

      showGeneralMessage(`Selected employees pushed to ${targetProcess} staging!`, true);
      return true;
    } catch (err) {
      showGeneralMessage(`Failed to sync with ${targetProcess}`, false);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading, data, setData,
    handleSearch,
    selectedYear, setSelectedYear,
    postToPayroll,
    refresh: fetchData
  };
};